module.exports = __webpack_public_path__ + "static/img/about-thumb.66f3b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-thumb.png
// module id = WsSy
// module chunks = 1